import { useCreateDealNoteMutation, useCreateDealTaskMutation, useDealActivity, useDealNotes, useDealTasks, useDealOverdueTasks, useDeleteDealNoteMutation, useDeleteDealTaskMutation, useUpdateDealNoteMutation, useUpdateDealTaskMutation } from "service/crm";
import Activity from "../Activity/Activity";
import { useDealNoteComments, useDealTaskComments } from "service/crm/hooks/comments/comment";


const DealActivity = ({ dealUuid }: { dealUuid: string }) => {
  return (
    <Activity
      entityUuid={dealUuid}
      useActivityQuery={useDealActivity}
      useNotesQuery={useDealNotes}
      useCreateNote={useCreateDealNoteMutation}
      buildNotePayload={(dealUuid, values) => ({
        dealUuid,
        note: values.note!.trim(),
        associatedPersonUuid: values.associatedPersonUuid,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })}
      useUpdateNote={useUpdateDealNoteMutation}
      buildUpdateNotePayload={(dealUuid, noteUuid, values) => ({
        dealUuid,
        noteUuid,
        note: values.note!.trim(),
        associatedPersonUuid: values.associatedPersonUuid,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })}
      useDeleteNote={useDeleteDealNoteMutation}
       buildDeleteNotePayload={(dealUuid, noteUuid) => ({
      dealUuid,
      noteUuid,
    })}
      noteCommentHooks={useDealNoteComments}
      useTasksQuery={useDealTasks}
    useOverdueTasksQuery={useDealOverdueTasks}
      useCreateTask={useCreateDealTaskMutation}
      buildTaskPayload={(dealUuid, values) => ({
        dealUuid,
        title: values.title!.trim(),
        description: values.description?.trim() || undefined,
        dueAt: values.dueAt,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        taskOwnerUuid: values.taskOwnerUuid,
        priority: values.priority,
        taskType: values.taskType,
        taskStatus:values.taskStatus
      })}
      useUpdateTask={useUpdateDealTaskMutation}
      buildUpdateTaskPayload={(dealUuid, taskUuid, values) => ({
        dealUuid,
        taskUuid,
        title: values.title!.trim(),
        description: values.description?.trim() || undefined,
        dueAt: values.dueAt,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        taskOwnerUuid: values.taskOwnerUuid,
        priority: values.priority,
        taskType: values.taskType,
        taskStatus:values.taskStatus
      })}
      useDeleteTask={useDeleteDealTaskMutation}
       buildDeleteTaskPayload={(dealUuid, taskUuid) => ({
      dealUuid,
      taskUuid,
    })}
      taskCommentHooks={useDealTaskComments}
    />
  );
};

export default DealActivity;
